import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { AppContext } from '../AppContext';
import { useEnvironmentTheme } from './Hooks';

const styles = theme => ({
  nestedLink: {
    fontSize: 14,
    opacity: 0.7,
    lineHeight: 0.5,
  },
});

const Navigation = withStyles(styles)(props => {
  const { classes } = props;
  const theme = useEnvironmentTheme();

  const {
    state: { sidenavLinks, sidenavLinksState },
    dispatch,
  } = useContext(AppContext);

  useEffect(() => {
    // console.log(sidenavLinks, sidenavLinksState)
  }, [sidenavLinks, sidenavLinksState]);

  const openLinkDropdown = fullRoute => {
    // get the first piece of the route which will be in the state variable
    const baseRoute = fullRoute.split('/')[1];
    let tempSidenavLinksState = Object.assign({}, sidenavLinksState);
    Object.keys(tempSidenavLinksState).forEach(key => (tempSidenavLinksState[key] = false));
    tempSidenavLinksState[baseRoute] = true;

    dispatch({
      type: 'UPDATE_SIDENAV_LINKS_STATE',
      sidenavLinksState: tempSidenavLinksState,
    });
  };

  const renderLinkRecursive = (link, fullRoute, isTabbed = false, isLastNestedLink = false) => {
    const TestComp = link.logo;
    const Component = TestComp ? <TestComp fontSize={'small'} /> : null;
    const baseRoute = fullRoute.split('/')[1];

    const filteredChildrenLinks = link.children ? link.children.filter(childLink => !childLink.hideNavLink) : [];

    return link.children && !link.hideChildrenNavLinks ? (
      // container for a dropdown of links
      <div
        key={link.label + link.label}
        style={{
          borderBottom: `0.5px solid ${theme.colors.primaryDark}`,
          backgroundColor: sidenavLinksState[baseRoute] ? theme.colors.primaryHover : '',
          paddingBottom: sidenavLinksState[baseRoute] ? 10 : 0,
        }}
      >
        <div className={classnames('navigation-link', 'hover-pointer')} onClick={() => openLinkDropdown(fullRoute)}>
          <div className="row-start-center">
            <span className="icon-container">
              {isTabbed ? (
                <span className="fake-logo-tab"></span>
              ) : (
                <div className={classnames('row-start-start')}>{Component}</div>
              )}
            </span>
            <span>{link.label}</span>
          </div>
          <ChevronRight
            className={classnames('navigation-link-dropdown-icon', sidenavLinksState[baseRoute] ? 'rotate-90' : '')}
          />
        </div>
        <div
          style={{
            paddingLeft: 25,
            display: sidenavLinksState[baseRoute] ? 'block' : 'none',
          }}
        >
          {filteredChildrenLinks.map((childLink, childLinkIdx) =>
            renderLinkRecursive(
              childLink,
              fullRoute + childLink.route,
              true,
              childLinkIdx === filteredChildrenLinks.length - 1,
            ),
          )}
        </div>
      </div>
    ) : (
      // link to go to a new page
      <Link
        to={fullRoute}
        key={link.label + link.label}
        className={classnames('navigation-link', 'row-start-center')}
        style={!isTabbed ? { borderBottom: `0.5px solid ${theme.colors.primaryDark}` } : {}}
      >
        <span className="icon-container">
          {isTabbed ? (
            <span className="navigation-link-tabbed"></span>
          ) : (
            // <div></div>
            <div className={classnames('row-start-start')}>{Component}</div>
            // <span className="fake-logo"></span>
          )}
        </span>
        <span className={classnames(isTabbed && classes.nestedLink)}>{link.label}</span>
      </Link>
    );
  };

  return <div className="navigation-container">{sidenavLinks.map(link => renderLinkRecursive(link, link.route))}</div>;
});

Navigation.propTypes = {
  // links: PropTypes.array.isRequired,
  qaMode: PropTypes.bool,
};

Navigation.defaultProps = {
  qaMode: false,
};

export default Navigation;
